import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    TrialInstitutionItemCategoryActions,
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID,
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_FAILURE,
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_CLEAR,
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_FILTER
} from '../actions/trialInstitutionItemCategory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionItemCategoryState {
    formData: Dtos.TrialInstitutionItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionItemCategory[];
    formLength: number;
}

const initialState: ITrialInstitutionItemCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialInstitutionItemCategoryState, _isLoading: boolean): ITrialInstitutionItemCategoryState {
    const newState: ITrialInstitutionItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialInstitutionItemCategoryState,
    formData: Dtos.TrialInstitutionItemCategory[],
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemCategoryState {
    const newState: ITrialInstitutionItemCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialInstitutionItemCategoryState, formFilter: IFormFilter): ITrialInstitutionItemCategoryState {

    const trialItemCategories: Dtos.TrialInstitutionItemCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = trialItemCategories ? trialItemCategories.length : 0;

    const formFilteredData = trialItemCategories ? trialItemCategories.filter(p => (formFilter.showInActive) &&
        (formFilter.search == "" || p.trialInstitutionItemTemplateCategory.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialInstitutionItemCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function loadFailure(state: ITrialInstitutionItemCategoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCategoryState {
    const newState: ITrialInstitutionItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionItemCategoryState, propertiesToClear?: string[]): ITrialInstitutionItemCategoryState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionItemCategoryState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const TrialInstitutionItemCategoryReducer: Reducer<ITrialInstitutionItemCategoryState> = (state: ITrialInstitutionItemCategoryState = initialState, action: TrialInstitutionItemCategoryActions) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_SUCCESS:
            return loadSuccess(state, action.formData, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMCATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONITEMCATEGORIES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialInstitutionItemCategoryReducer;